export default __webpack_public_path__ + "static/media/multiple_bg.71e28d06.png";